<template>
    <div>
        <label>Signature <small class="text-muted"><em>(click image box to upload)</em></small></label>                    
        <div id="signature-preview" class="signature-preview" @click="show()">
            <img v-if="value" :src="'data:image/png;base64,' + value" />
        </div>

        <div id="signature-modal" class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Upload Signature</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div id="modalBody" class="modal-body">
                        <form id="signatureDropzone" class="dropzone" ref="signatureDropzone">
                            <input type="hidden" name="_token" :value="csrf">
                            <input type="hidden" name="id" :value="id">
                            <div class="dz-message" data-dz-message>
                                <span class="text-muted">Drop the signature image file (.png) here or click to browse your computer.</span>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button id="button-accept" type="button" class="btn btn-primary" @click="accept()">Accept</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>               
    </div>
</template>

<script>
// prevent dropzone from auto discovering this element; we will instantiate it in the vue mounted event handler
Dropzone.options.signatureDropzone = false;

export default {
    props: {
        id: Number,
        value: String,
        href: String
    },
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            signatureDropzone: undefined,
            editor: undefined,
            croppie: undefined,
            thumb: undefined,
            callback: undefined,
            width: 500,
            height: 68
        }
    },
    methods: {
        show: function () {
            $('#signature-modal').modal('show');
        },
        accept: function () {
            var self = this;
            self.croppie.result({
                type: 'blob',
                size: {
                    width: self.width,
                    height: self.height
                }
            }).then(function (blob) {

                self.signatureDropzone.createThumbnail(
                    blob,
                    120, //signatureDropzone.get(0).dropzone.options.thumbnailWidth,
                    120, //signatureDropzone.get(0).dropzone.options.thumbnailHeight,
                    'contain', //signatureDropzone.get(0).dropzone.options.thumbnailMethod,
                    false,
                    function (dataURL) {
                        self.signatureDropzone.emit('thumbnail', self.thumb, dataURL);
                        self.callback(blob);
                    }
                );
            });
            
            this.editor.parentNode.removeChild(this.editor);            
        }
    },
    mounted() {
        var self = this;
        self.signatureDropzone = new Dropzone(self.$refs.signatureDropzone, {
            url: self.href,
            timeout: 15000,
            autoProcessQueue: true,
            uploadMultiple: false,
            parallelUploads: 1,
            maxFiles: 1,       
            transformFile: function (file, done) {

                self.thumb = file;
                self.callback = done;

                // create the image editor overlay
                self.editor = document.createElement('div');
                self.editor.id = 'editor';
                self.editor.style.position = 'absolute';
                self.editor.style.left = 0;
                self.editor.style.right = 0;
                self.editor.style.top = 0;
                self.editor.style.bottom = 0;
                self.editor.style.zIndex = 9999;
                self.editor.style.backgroundColor = '#fff';                        
                $('#modalBody').append(self.editor);

                self.croppie = new Croppie(self.editor, {
                    enableExif: true,
                    viewport: {
                        width: self.width,
                        height: self.height,
                        type: 'square'
                    },
                    boundary: {
                        width: self.width + 50,
                        height: self.height + 50,
                    },
                    customClass: 'pt-5'                       
                });

                // pass the image to the editor 
                self.croppie.bind({
                    url: URL.createObjectURL(file)
                });
            },
            success(files, response) {
                $('#signature-modal').modal('hide');
                window.location.reload();                                
            },
            error(file, response) {
                $('#signature-modal').modal('hide');
                let message = response.message ? response.message : response;
                toastr['error'](message, 'ERROR', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
            }            
        });
    }    
}
</script>

<style scoped>

</style>